var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"log"}},_vm._l((10),function(i){return _c('p',[_vm._v("我是日志测试测试")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }